module.exports = __webpack_public_path__ + "assets/img/9.8a664ac9.png";